import { Avatar, AvatarProps, Badge } from '@mui/material'

export interface AvatarWithStatusProps {
  src?: string
  alt: string
  isHide?: boolean
  avtProps?: Omit<AvatarProps, 'src' | 'alt' | 'children'>
}

export const AvatarWithStatus = ({ src, alt, isHide, avtProps }: AvatarWithStatusProps) => {
  return (
    <Badge
      overlap="circular"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      variant="dot"
      invisible={isHide}
      sx={{
        '& .MuiBadge-badge': {
          backgroundColor: '#44b700',
          color: '#44b700',
          boxShadow: `0 0 0 1px white`,
          '&::after': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            animation: 'ripple 1.2s infinite ease-in-out',
            border: '1px solid currentColor',
            content: '""',
          },
        },
        '@keyframes ripple': {
          '0%': {
            transform: 'scale(.8)',
            opacity: 1,
          },
          '100%': {
            transform: 'scale(2.4)',
            opacity: 0,
          },
        },
      }}
    >
      <Avatar
        alt={alt}
        sx={{ width: { xs: 24, md: 32 }, height: { xs: 24, md: 32 }, ...avtProps?.sx }}
        src={src || '/assets/images/ava-default.png'}
        {...avtProps}
      />
    </Badge>
  )
}
